module.exports = __webpack_public_path__ + "img/anonymous-pro-light.35f695b9.png";